// @ts-ignore

import { View } from 'native-base';

const MapView = View;
const Marker = View;

export { MapView, Marker };
